import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxButtonModule, DxDropDownButtonModule, DxToolbarModule} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {ButtonWithIconObject, DynamicButton} from "../../../constants";
import {FormYetkiDto} from "../../../models/ortak.dtos";
import {AuthService} from "../../../../../../../auth/src/lib/auth.service";
import Button from "devextreme/ui/button";
import {TamEkranService} from "../../../services/tam-ekran.service";
import {TamEkranDugmesiComponent} from "../tam-ekran-dugmesi/tam-ekran-dugmesi.component";
import {YardimDugmesiComponent} from "../yardim-dugmesi/yardim-dugmesi.component";

@Component({
  selector: 'dk-form-header',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxDropDownButtonModule, DxToolbarModule, DxiItemModule, TamEkranDugmesiComponent, YardimDugmesiComponent],
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss'],
})
export class FormHeaderComponent implements OnInit, OnDestroy {
  @Input() public state: string;
  @Input() public formYetkiler: FormYetkiDto;
  @Input() public donemAktif: boolean=true;
  //@Input() public ambarAktif: boolean=true;
  @Input() public editMode: boolean;
  @Input() public closeButton: boolean = true;
  @Input() public saveAndContinue: boolean = false;
  @Input() public formActions: ButtonWithIconObject[];
  @Input() public isEditable!: boolean;
  @Input() public viewToEdit: boolean=false;
  @Input() public makeThisButtonActive: string = '';
  @Input() public formName: string;
  @Input() public customInfo!: string;
  @Input() public saveButtonTitle!: string;
  @Input() public editButtonTitle!: string;
  @Input() public newCancelOrCLoseBtn: string= 'Kapat';
  @Input() public removeSaveButton!: boolean;
  @Input() public removeEditButton!: boolean;
  @Input() public removeSaveNearCancel!: boolean;
  @Input() public widthChange = false
  @Input() public isLoading:boolean = false;
  @Input() dynamicButtons: DynamicButton[];
  @Output() onActionItemClick = new EventEmitter<any>();
  @Output() onSaveButtonClick = new EventEmitter<void>();
  @Output() onSaveAndContinueButtonClick = new EventEmitter<void>();
  @Output() onCloseButtonClick = new EventEmitter<void>();
  @Output() onEditButtonClick = new EventEmitter<void>();
  @Output() onTuretEditButtonClick = new EventEmitter<void>();
  @Output() onCancelButtonClick = new EventEmitter<void>();
  @Output() onFullWidthButtonClick = new EventEmitter<void>();
  @Output() dynamicButtonClicked = new EventEmitter<void>();
  isAdmin = false

  showDynamicButtons = true;
  showKapat = true;

  constructor( private authService:AuthService, public tamEkran: TamEkranService, public el: ElementRef<HTMLElement>) {
  }

  ngOnDestroy() {
    this.tamEkran.ayril(this.el.nativeElement);
  }

  ngOnInit() {
    this.tamEkran.kaydol(this.el.nativeElement);
    this.isAdmin = this. authService.isUserAdmin()
    // if(this.isAdmin){
    //   if (!this.formYetkiler) {
    //     this.formYetkiler = new FormYetkiDto();
    //   }
    //   this.formYetkiler.deleteYn = true
    //   this.formYetkiler.updateYn = true
    //   this.formYetkiler.insertYn = true
    //   this.formYetkiler.executeYn = true
    //   this.formYetkiler.exportYn = true
    // }
    if (this.customInfo) {
      this.customInfo = this.customInfo.replace(' ', '     ');
    }
  }

  onActionsItemClick($event: any) {
    this.onActionItemClick.emit($event); // Emit the onItemClick event
  }

  handleSaveClick() {
    this.onSaveButtonClick.emit()
  }
  handleSaveAndContinueClick() {
    this.onSaveAndContinueButtonClick.emit()
  }

  handleEditClick() {
    this.editMode = !this.viewToEdit;
    this.onEditButtonClick.emit()
  }

  handleTuretClick() {
    this.editMode = !this.viewToEdit;
    this.onTuretEditButtonClick.emit()
  }

  onCloseClick() {
    this.onCloseButtonClick.emit()
  }

  handleCancelClick() {
    //this.editMode = false;
    this.onCancelButtonClick.emit()
  }

  handleWidthClick() {
    this.onFullWidthButtonClick.emit()
  }

  handleDynamicButtonClick(dynamicButton: any) {
    this.dynamicButtonClicked.emit(dynamicButton)
  }
  trackByFn(index: number, item: DynamicButton): string | number {
    return item.name ?? item.hint ?? index;
  }
  onContentReady(e: any) {
    let buttonElement = e.element.querySelectorAll(
      ".dx-toolbar-menu-container .dx-dropdownmenu-button"
    )[0];

    let buttonInstance = Button.getInstance(buttonElement);

    if(buttonInstance){
      buttonInstance.option("icon", "menu");
      buttonInstance.option("hint", "Diğer İşlemler"); // tooltip
    }
  }
}
